import { Dtos } from "@inrev/common";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const bondNumbersQueryKey = ["admin", "bondNumbers"];

export const useAdminFetchBondNumbers = () => {
	const { get } = useRequest();
	const queryClient = useQueryClient();

	const { data, error, isLoading } = useQuery({
		queryKey: bondNumbersQueryKey,
		queryFn: async () =>
			await get<Dtos.BondNumber.GetAll.Response>("/v2/admin/surety/bond-numbers"),
	});

	return {
		bondNumbers: data ?? [],
		bondNumbersLoading: isLoading,
		bondNumbersError: error,
		invalidateBondNumbers: () => queryClient.invalidateQueries({ queryKey: bondNumbersQueryKey }),
	};
};
